import React from "react";
import { Tooltip, TooltipProps, styled } from "@mui/material";

interface StyledTooltipProps extends TooltipProps {
  type: "dark" | "light";
  scrollable?: boolean;
}

const ToBeStyledTooltip = ({ className, ...props }: StyledTooltipProps) => (
  <Tooltip {...props} classes={{ tooltip: className }} />
);

export const StyledTooltip = styled(ToBeStyledTooltip, {
  shouldForwardProp: (propName) => propName !== "type",
})(({ theme, type, scrollable }) => ({
  backgroundColor: theme.wsc.palette.neutral[type === "dark" ? 800 : 100],
  color: theme.wsc.palette.neutral[type === "dark" ? 100 : 700],
  border: `0.071rem solid ${theme.wsc.palette.neutral[500]}`,
  fontSize: theme.wsc.typography.body2.fontSize,
  fontWeight: theme.wsc.typography.body2.fontWeight,
  padding: theme.wsc.spacing[1],
  borderRadius: theme.wsc.radius.m,
  boxShadow: theme.wsc.shadow.s1,
  ...(scrollable && {
    maxHeight: `calc(${theme.wsc.size.xxl} * 5.35)`,
    overflow: "auto",
    paddingRight: theme.wsc.size.xs,
    "&::-webkit-scrollbar": {
      width: `calc(${theme.wsc.size.s} * 1.5)`,
      borderRadius: theme.wsc.radius.m,
    },
    "&::-webkit-scrollbar-thumb": {
      background: theme.wsc.palette.neutral[200],
      borderRadius: theme.wsc.radius.m,
      border: `${theme.wsc.size.xs} solid transparent`,
      backgroundClip: "content-box",
      "&:hover": {
        background: theme.wsc.palette.neutral[300],
        border: `${theme.wsc.size.xs} solid transparent`,
        backgroundClip: "content-box",
      },
    },
  }),
}));
